__turbopack_context__.v({
  "cap": "sort-control-module__Cbyxsa__cap",
  "chev": "sort-control-module__Cbyxsa__chev",
  "current": "sort-control-module__Cbyxsa__current",
  "label": "sort-control-module__Cbyxsa__label",
  "leadIcon": "sort-control-module__Cbyxsa__leadIcon",
  "trigger": "sort-control-module__Cbyxsa__trigger",
});
